import React from 'react';

export const apiUrl
    = window.location.hostname === 'localhost' ? 'http://localhost:5000' : 'https://camba-apis.herokuapp.com';

export const ApiContext = React.createContext(apiUrl);
